/* eslint-disable react/style-prop-object, react/no-unknown-property */
import { h } from 'preact';
import SVGWrapper from '../../../../../../common/components/svg/SvgWrapper';

function PlaylistIcon({ height = 60, width = 60, color = 'white', ...props }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g fill={color}>
        <path d="m20.4001 8.92502v1.34998h-9v-1.34998z" />
        <path d="m20.4001 13.725v1.35h-9v-1.35z" />
        <path d="m12.0001 6.00002c2.8415 0 5.6444-.16497 8.4-.48515v-1.35996c-2.7546.32633-5.5576.49511-8.4.49511-2.84237 0-5.64542-.16878-8.4-.49511v1.35996c2.75556.32018 5.55853.48515 8.4.48515z" />
        <path d="m12.0001 18c2.8415 0 5.6444.165 8.4.4852v1.3599c-2.7546-.3263-5.5576-.4951-8.4-.4951-2.84237 0-5.64542.1688-8.4.4951v-1.3599c2.75556-.3202 5.55853-.4852 8.4-.4852z" />
        <path d="m3.6001 9.03049c0-.52071.58636-.82997 1.02011-.54199.77147.51257 1.83795 1.2035 2.6795 1.6805.79753.452 1.86157.9781 2.69941 1.3793.51088.2446.49718.9924-.02226 1.2181l-.6586.2895c-.68475.3052-1.42487.6488-2.01855.9574l-.32754.174c-.78487.4253-1.6951.9714-2.37188 1.3875-.40771.2507-.93011-.0072-.99375-.4611l-.00644-.0932zm1.35 4.75721c.57454-.3402 1.18999-.693 1.72676-.9721.43199-.2245.93154-.4642 1.4291-.6931-.51205-.2583-1.02819-.5278-1.47188-.7793-.52387-.2969-1.122-.6685-1.68398-1.0283z" />
      </g>
    </SVGWrapper>
  );
}

export default PlaylistIcon;
